export const DICTIONARIES_TABLE_ROW_COLUMNS = 4
